import InconsistenciesBeneficiarioLote from './inconsistencies-beneficiario-controller';

export {
  InconsistenciesBeneficiarioLote,
};
